import { render, staticRenderFns } from "./SelectKolonne.vue?vue&type=template&id=6004658a"
import script from "./SelectKolonne.vue?vue&type=script&lang=js"
export * from "./SelectKolonne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports